'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002425 from "./presto.-Login-Page-View$$anon$25.js";
import * as $j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse$0024 from "./presto.types$proto$-Generic-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$24() {
  this.b6G = null;
  this.b6y = null;
  this.b6z = false;
  this.b6H = null;
  this.b6I = false;
  this.b6L = null;
  this.b6E = null;
  this.b6F = false;
  this.b6A = null;
  this.b6B = false;
  this.b6C = null;
  this.b6D = false;
  this.b6J = false;
  this.b6K = false;
  this.b6G = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6L = "GenericResponse";
}
export { $c_Lpresto_LoginPageView$$anon$24 as $c_Lpresto_LoginPageView$$anon$24 };
$p = $c_Lpresto_LoginPageView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$24;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$24() {
}
export { $h_Lpresto_LoginPageView$$anon$24 as $h_Lpresto_LoginPageView$$anon$24 };
$h_Lpresto_LoginPageView$$anon$24.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b6G;
});
$p.L = (function() {
  if ((!this.b6z)) {
    this.b6y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b6z = true;
  }
  return this.b6y;
});
$p.O = (function() {
  if ((!this.b6I)) {
    this.b6H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b6I = true;
  }
  return this.b6H;
});
$p.E = (function() {
  return this.b6L;
});
$p.t = (function() {
  if ((!this.b6F)) {
    this.b6E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("error", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b6F = true;
  }
  return this.b6E;
});
$p.M = (function() {
  if ((!this.b6B)) {
    this.b6A = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b6B = true;
  }
  return this.b6A;
});
$p.Q = (function() {
  if ((!this.b6D)) {
    this.b6C = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002425.$c_Lpresto_LoginPageView$$anon$25();
    this.b6D = true;
  }
  return this.b6C;
});
$p.w = (function() {
  if ((!this.b6K)) {
    this.b6J = false;
    this.b6K = true;
  }
  return this.b6J;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee156) => ((p) => \u03b4scrutinee156.cGL(p)))($j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse$0024.$m_Lpresto_types$proto$GenericResponse$())));
});
var $d_Lpresto_LoginPageView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$24, "presto.LoginPageView$$anon$24", ({
  Mf: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$24 as $d_Lpresto_LoginPageView$$anon$24 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$24.js.map
